import { render, staticRenderFns } from "./InvitationAward.vue?vue&type=template&id=3ed02ec6&scoped=true&"
import script from "./InvitationAward.vue?vue&type=script&lang=js&"
export * from "./InvitationAward.vue?vue&type=script&lang=js&"
import style0 from "./InvitationAward.vue?vue&type=style&index=0&id=3ed02ec6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed02ec6",
  null
  
)

export default component.exports